import { render, staticRenderFns } from "./tabVesselGallery.vue?vue&type=template&id=76b61976&"
import script from "./tabVesselGallery.vue?vue&type=script&lang=js&"
export * from "./tabVesselGallery.vue?vue&type=script&lang=js&"
import style0 from "./tabVesselGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports